import { __ } from '@wordpress/i18n';
import { InspectorControls } from '@wordpress/block-editor';

const PanelSettings = ({ isSelected}) => {
	return (
		isSelected && (
			<InspectorControls>
				<div className="th-block-ins th-button-panel">
					<div className="vb-faq-notice">
						<p>{__('To customize styling options, please select the parent FAQ block.', 'vayu-blocks')}</p>
					</div>
				</div>
			</InspectorControls>
		)
	);
};

export default PanelSettings;
